export const formatThousandth: any = (number: number | string) => {

  // 转为字符串，并按照 . 拆分
  const arr = String(Number(number)?.toFixed(2)).split(".");
  // 整数拆分
  const int = Number(number) < 0 ? arr[0].split("").slice(1) : arr[0].split("");
  // 小数
  const fraction = arr[1] || "";
  let res = "";
  if (int?.length <= 3) {
    res = int.join("")
  } else {
    int.forEach((item, index) => {
      // 非第一位且是 3 的倍数，添加 ","
      if (index !== 0 && (int.length - index) % 3 === 0) {
        res = res + "," + item;
      } else {
        // 正常添加字符
        res = res + item;
      }
    });
  }
  
  // 整数和小数拼接
  return (Number(number) < 0 ? '-': '') +res + (!!fraction ? `.${fraction}` : "");
}
export const prefix_url = "/Dealerportal";